import React, { useEffect, useState } from 'react';
import { BLACK, UNIT } from '../../../../constants';
import { Check, LocationOnOutlined } from '@mui/icons-material';
import styles from '../../AddressInput.styles';
import Spinner from '../../../Spinner';
import {
  AutocompleteSuggestionType,
  fetchSuggestions,
  handleSelectSuggestion,
  handleTypedAdress,
} from './AddressSearchAutocomplete.service';

type AddressSearchAutocompleteInputProps = {
  typedAddress: string;
  setTypedAddress: React.Dispatch<React.SetStateAction<string>>;
  handleAddressSelection: (
    selectedAddressValue: any,
    placeId: string
  ) => Promise<void>;
  handleAddressInputFormControlError: (
    status: any,
    clearSuggestions: () => void
  ) => void;
  hasErrorAddressMessage: boolean;
  getShopsIsLoading: boolean;
  showShopsDropdownList: (
    isCutomerAddressSelected?: boolean,
    hasErrorOnAddress?: boolean,
    orderTypeSelected?: any
  ) => boolean;
  inputElementRef: React.MutableRefObject<any>;
  animatePlaceholder: string;
  isFilledAddressValid: boolean;
  lastTypedAddressValidValue: string;
};

export default function AddressSearchAutocompleteInput({
  typedAddress,
  setTypedAddress,
  handleAddressSelection,
  handleAddressInputFormControlError,
  hasErrorAddressMessage,
  getShopsIsLoading,
  showShopsDropdownList,
  inputElementRef,
  animatePlaceholder,
  isFilledAddressValid,
  lastTypedAddressValidValue,
}: AddressSearchAutocompleteInputProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    const timeoutId = setTimeout(
      () =>
        fetchSuggestions(
          typedAddress,
          isFilledAddressValid,
          setSuggestions,
          setIsLoading,
          handleAddressInputFormControlError,
          lastTypedAddressValidValue
        ),
      400
    );
    return () => clearTimeout(timeoutId);
  }, [typedAddress, isFilledAddressValid]);

  return (
    <>
      <div>
        <div
          className={`inputStyle ${
            hasErrorAddressMessage && !getShopsIsLoading && 'border-red'
          }`}
          style={{
            marginBottom: showShopsDropdownList() ? UNIT * 0.875 : 0,
          }}
        >
          <LocationOnOutlined
            className='fa-map-marker'
            style={{ ...styles.space }}
          />
          <input
            className={`form-control no-localization dark-modal`}
            ref={inputElementRef}
            placeholder={animatePlaceholder}
            style={{ ...styles.addressInput }}
            type='text'
            onChange={(e) =>
              handleTypedAdress(e.target.value, setTypedAddress, setSuggestions)
            }
            value={typedAddress}
          />
          {isFilledAddressValid && (
            <Check
              style={styles.space}
              className='fa-check'
            />
          )}
        </div>
        <div
          className='autocomplete-dropdown-container'
          style={{ position: 'absolute', zIndex: 5000, width: '100%' }}
        >
          {isLoading && <Spinner />}
          {suggestions?.map((suggestion: AutocompleteSuggestionType) => {
            const className = suggestion?.active
              ? 'suggestion-item--active p-2'
              : 'suggestion-item p-2';
            const style = suggestion?.active
              ? {
                  backgroundColor: '#fafafa',
                  cursor: 'pointer',
                  color: BLACK,
                  width: '100%',
                }
              : {
                  backgroundColor: '#ffffff',
                  cursor: 'pointer',
                  color: BLACK,
                  width: '100%',
                };
            return (
              <div
                key={suggestion.placeId}
                className={className}
                style={style}
                onClick={() =>
                  handleSelectSuggestion(suggestion, handleAddressSelection)
                }
              >
                <strong className='no-localization'>
                  {suggestion?.formattedSuggestion?.mainText}
                </strong>{' '}
                <small className='no-localization'>
                  {suggestion?.formattedSuggestion?.secondaryText}
                </small>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
